import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';

import text from './UserControl.form.component.translation';

export class FormUserControl extends Component {
  _onValidate = (err, formValues) => {
    if (!err) {
      const formControlSubmit = {
        old_password: formValues.oldpassword,
        new_password: formValues.newpassword,
      };
      this.props.onSubmit(formControlSubmit);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
    } = this.props;
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="field">
          <Form.Item
            label={formatMessage(text.oldLabel)}
            required={false}
            colon={false}
          >
            {getFieldDecorator('oldpassword', {
              rules: [
                {
                  required: true,
                  message: formatMessage(text.required),
                },
                {
                  pattern: '^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,16}$))',
                  message: formatMessage(text.validation),
                },
              ],
            })(
              <Input.Password
                size="large"
                placeholder={formatMessage(text.oldPlaceholder)}
                style={{ width: '50%' }}
              />,
            )}
          </Form.Item>
        </div>

        <div className="field">
          <Form.Item
            label={formatMessage(text.newLabel)}
            required={false}
            colon={false}
          >
            {getFieldDecorator('newpassword', {
              rules: [
                {
                  required: true,
                  message: formatMessage(text.required),
                },
                {
                  pattern: '^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,16}$))',
                  message: formatMessage(text.validation),
                },
              ],
            })(
              <Input.Password
                size="large"
                placeholder={formatMessage(text.newPlaceholder)}
                style={{ width: '50%' }}
              />,
            )}
          </Form.Item>
        </div>

        {this._renderSubmit()}
      </Form>
    );
  };

  _renderSubmit = () => (
    <Button
      type="primary"
      block
      className="btn"
      htmlType="submit"
      style={{
        width: '120px',
        height: '48px',
        fontSize: '18px',
        fontWeight: '600',
      }}
      loading={this.props.isFetching}
    >
      {this.props.intl.formatMessage(text.submit)}
    </Button>
  );

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormUserControl.propTypes = {
  isFetching: PropTypes.bool,
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default FormUserControl;
